import React, { useEffect, useState } from 'react'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon'
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../components/elements/Loader';
import DataTable from '../../../../components/elements/DataTable';
import { debounce, tableHeadersFields } from '../../../../utils';
import { clearCreatedInvoice, fetchInvoices } from '../../../../store/actions/invoicesActions';
import ModalDialog from '../../../../components/layouts/ModalDialog';
import SearchField from '../../../../components/elements/SearchField';
import InvoicesFilters from '../../../../components/elements/filters/InvoicesFilters';
import CreateNewInvoice from '../../../../components/partials/invoices/CreateNewInvoice';
import { SET_SUCCESS } from '../../../../store/types';
import { useNavigate } from 'react-router-dom';

export const FeesDisplay = ({fees}) => {
  return (
    <div className='w-full'>
      {fees.slice(0,2).map((fee, feeIndex)=>(
        <span key={feeIndex} className='p-[5px] mr-[5px] mb-[5px] inline-block text-xs text-gray-600 bg-gray-100 rounded'>
          {fee.fee.name} (x{fee.quantity})
        </span>
      ))}
      {fees.length > 2 && <span className='p-[5px] mr-[5px] mb-[5px] inline-block text-xs text-gray-400 bg-gray-100 rounded'>+{fees.length - 2} more</span>}
    </div>
  )
}

const Invoices = () => {
  const dispatch = useDispatch()
  const invoicesSelector = useSelector(state => state.invoices)
  const navigate = useNavigate()
  const [filters, setFilters] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 25
  });
  const [reload, setReload] = useState(0);

  useEffect(() => {
    dispatch(fetchInvoices(filters, pagination.page, pagination.perPage))
    if(invoicesSelector.createdInvoice !== null){
      dispatch(clearCreatedInvoice())
      dispatch({
        type: SET_SUCCESS,
        payload: 'Invoice created successfully!'
      })
      setCreatingInvoice(false)
    }
    return () => {
      
    };
  }, [dispatch, filters, pagination.page, pagination.perPage, reload, invoicesSelector.createdInvoice]);

  const [creatingInvoice, setCreatingInvoice] = useState(false);

  const transactionColumnWidths = {
    invoiceCode: 'w-1/12',
    nameAndDescription: 'w-4/12',
    fees: 'w-4/12',
    totalAmount: 'w-1/12',
    dateCreated: 'w-2/12',
  }
    
  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{navigate(invoicesSelector.invoices?.invoices[index]._id)}
  }

  const columnDataStyles = {}

  const cleanupData = (dataSet) => {
    if(!dataSet) return []
    const data = []

    dataSet.forEach((item, itemIndex) => {
        data.push(
            {
              invoiceCode: <p className='mt-[5px]'>{item.invoiceCode}</p>,
              nameAndDescription: <div>
                <p className='text-black text-sm font-[500]'>{item.name}</p>
                <p className='text-xs text-gray-400'>{item.description}</p>
              </div>,
              fees: <FeesDisplay fees={item.fees} />,
              totalAmount: <p className='font-space-grotesk'>₦{(item.total/100).toLocaleString()}</p>,
              dateCreated: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
            },
        )
    })

    return data
  }

  const [setSelectedInvoicesCount] = useState(0)

  const getSelectionCount = (count) => {
      return setSelectedInvoicesCount(count)
  }

  const searchApplicants = debounce((term) => {
    if(!term || term === '') setReload(reload + 1)
    dispatch(fetchInvoices(`name=${term}&applicationCode=${term}`, 0, 0))
  })

  return (
    <>
      <div className="w-full">
          <div className='py-3 mb-2'>
              <div className="w-full mx-auto">
                  <div className='w-full flex items-center justify-between'>
                      <div className='w-2/3'>
                          <h4 className='font-medium text-lg mb-3 text-gray-400'>Invoices</h4>
                          <div className=''>
                              <p className='text-gray-500 mt-1 text-sm'>
                                  Below is a list of payments to Vaatia College
                              </p>
                          </div>
                      </div>
                      <button onClick={()=>{setCreatingInvoice(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                          Create an Invoice
                      </button>
                  </div>

                  <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                      <div className='w-full'>
                          <InvoicesFilters applyFilters={(filters)=>{
                            console.log('filters => ', filters)
                            setFilters(filters)
                          }} 
                        />
                      </div>
                      <div className='w-full flex flex-row-reverse gap-x-2'>
                          <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                            <ArrowUpTrayIcon className={`w-5 h-5`} />
                            Export Invoices
                          </button>
                          <div className='w-[350px]'>
                            <SearchField 
                              placeholderText={`Search for invoice by name or invoice code`}
                              showResultsDropDown={false}
                              triggerSearch={(term)=>{searchApplicants(term)}}
                              performingSearch={invoicesSelector.loadingInvoices}
                            />
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className=''>
              {invoicesSelector.loadingInvoices
                  ? 
                    <div className='w-full'>
                        <Loader />
                    </div>
                  : 
                    <DataTable
                      tableHeaders={tableHeadersFields(cleanupData(invoicesSelector.invoices?.invoices)[0]).headers} 
                      tableData={cleanupData(invoicesSelector.invoices?.invoices)} 
                      columnWidths={transactionColumnWidths}
                      columnDataStyles={columnDataStyles}
                      allFields={tableHeadersFields(cleanupData(invoicesSelector.invoices?.invoices)[0]).fields}
                      onSelectItems={getSelectionCount}
                      tableOptions={tableOptions}
                      pagination={{
                          perPage: pagination.perPage, 
                          currentPage: pagination.page,
                          totalItems: invoicesSelector.invoices.total,
                      }}
                      changePage={(page) => {setPagination({...pagination, ...{page: page}})}}
                      updatePerPage={(perPage) => {setPagination({...pagination, ...{perPage: perPage}})}}
                    />
              }
          </div>
      </div>

      <ModalDialog
          shown={creatingInvoice} 
          closeFunction={()=>{setCreatingInvoice(false)}} 
          actionFunction={()=>{}} 
          actionFunctionLabel={``}
          dialogTitle='Create a new invoice'
          maxWidthClass='max-w-4xl'
          hideActions={true}
      >
        <CreateNewInvoice closeFunction={()=>{setCreatingInvoice(false)}} />
      </ModalDialog>
    </>
  )
}

export default Invoices